module.exports = __webpack_public_path__ + "static/media/catalog_website.7cb585ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background/catalog_website.png
// module id = 587
// module chunks = 2